import React, { useRef, useEffect, useState, useMemo } from 'react';
import './Authors.css';

import auth1 from '../assets/auth1.webp';
import auth2 from '../assets/auth2.webp';
import auth3 from '../assets/auth3.webp';
import auth4 from '../assets/auth4.webp';
import auth5 from '../assets/auth5.webp';
import auth6 from '../assets/auth6.webp';
import auth7 from '../assets/auth7.webp';
import auth8 from '../assets/auth8.webp';
import auth9 from '../assets/auth9.webp';
import auth10 from '../assets/auth10.webp';
import auth11 from '../assets/auth11.webp';
import auth12 from '../assets/auth12.webp';

import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';


// Для каждой картинки задаём начальные (start) и конечные (end) позиции
const positions = [
  { start: { top: '5%', left: '200px' }, end: { top: '-3%', left: '-100px' } },
  { start: { top: '15%', left: '55%' }, end: { top: '5%', left: '30%' } },
  { start: { top: '30%', left: '25%' }, end: { top: '15%', left: '5%' } },
  { start: { top: '30%', left: '55%' }, end: { top: '40%', left: '40%' } },
  { start: { top: '40%', left: '5%' }, end: { top: '50%', left: '0%' } },
  { start: { top: '55%', left: '30%' }, end: { top: '80%', left: '20%' } },
  { start: { top: '0%', left: '2%' },   end: { top: '0%', left: '25%' } },
  { start: { top: '5%', left: '45%' },   end: { top: '25%', left: '70%' } },
  { start: { top: '25%', left: '25%' },   end: { top: '40%', left: '30%' } },
  { start: { top: '35%', left: '35%' },   end: { top: '48%', left: '90%' } },
  { start: { top: '50%', left: '5%' },   end: { top: '60%', left: '10%' } },
  { start: { top: '53%', left: '30%' },   end: { top: '73%', left: '50%' } }
];

const sizes = [
  '30%', '35%', '30%', '40%', '35%', '30%',
  '45%', '30%', '35%', '30%', '30%', '35%'

];

const IMAGES = [
  auth1, auth2, auth3, auth4, auth5, auth6,
  auth7, auth8, auth9, auth10, auth11, auth12
];

// Интерполируем между start и end в зависимости от фактора (0–1)
const interpolate = (start, end, factor) => {
  const unit = start.endsWith('%') ? '%' : 'px';
  const s = parseFloat(start);
  const e = parseFloat(end);
  return `${s + (e - s) * factor}${unit}`;
};

export default function Authors() {
  const { t, i18n } = useTranslation();
  const containerRef = useRef(null);
  const [scrollFactor, setScrollFactor] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Определяем мобильное устройство
  useEffect(() => {
    const mq = window.matchMedia('(min-width: 768px) and (orientation: portrait), (min-width: 1025px)');
    const handler = (e) => setIsMobile(!e.matches);
    handler(mq);
    mq.addListener(handler);
    return () => mq.removeListener(handler);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      if (!containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const viewHeight = window.innerHeight;
      const start = viewHeight;
      const progress = (rect.top - start) / (0 - start - rect.height);
      const factor = Math.min(Math.max(progress, 0), 1);
      setScrollFactor(factor);
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="authors-grid" ref={containerRef}>
      {!isMobile ? (
        <>
          {/* Десктоп: три колонки */}
          <div className="side-column left-column">
            {IMAGES.slice(0, 6).map((src, i) => {
              const { start, end } = positions[i];
              const top  = interpolate(start.top, end.top, scrollFactor);
              const left = interpolate(start.left, end.left, scrollFactor);
              const size = sizes[i];
              return (
                <img
                  key={i}
                  src={src}
                  className="author-img"
                  alt=""
                  style={{ top, left, opacity: 1, width: size, height: 'auto' }}
                />
              );
            })}
          </div>

          <div className="center-column" style={{display: 'flex', flexDirection: 'column'}}>
            <p style={{fontSize: '32px', marginTop: '100px'}}>
              <Trans
                i18nKey="$Header5"
                components={{ highlight: <b></b> }}
              />
            </p>
            <div style={{margin: 'auto', marginTOp: '200px'}}>
            <p style={{marginTop: '64px', marginBottom: '32px'}}>
              {t('$Subheader7')}
            </p>
            <p style={{ background: 'linear-gradient(90deg, #3466F8 42.79%, #CF4EE6 63.46%, #F6275D 89.9%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', margin: '0', fontSize: '24px'}}>
              <b>{t('$Subheader8')}</b>
            </p>
            <p style={{margin: '4px', fontSize: '24px'}}>
              <b>
              {t('$Subheader9')}
              </b>
            </p>
            <p style={{textAlign: 'center', marginBottom: '40px' }}>
              {t('$Text1')}
            </p>
            </div>
          </div>

          <div className="side-column right-column">
            {IMAGES.slice(6).map((src, idx) => {
              const i = idx + 6;
              const { start, end } = positions[i];
              const top  = interpolate(start.top, end.top, scrollFactor);
              const left = interpolate(start.left, end.left, scrollFactor);
              const size = sizes[i];
              return (
                <img
                  key={i}
                  src={src}
                  className="author-img"
                  alt=""
                  style={{ top, left, opacity: 1, width: size, height: 'auto' }}
                />
              );
            })}
          </div>
        </>
      ) : (
        <>
          {/* Мобильная версия */}
          <div className="mobile-text" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '20px'}}>
            <p style={{fontSize: '20px'}}>
              <Trans
                i18nKey="$Header5"
                components={{ highlight: <b></b> }}
              />
              </p>
            <p style={{marginBottom: '32px'}}>
              {t('$Subheader7')}
            </p>
            <p style={{ background: 'linear-gradient(90deg, #3466F8 42.79%, #CF4EE6 63.46%, #F6275D 89.9%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', margin: '0'}}>
              <b>{t('$Subheader8')}</b>
            </p>
            <p style={{margin: '4px'}}>
              <b>
              {t('$Subheader9')}
              </b>
            </p>
            <p style={{textAlign: 'center'}}>
              {t('$Text1')}
            </p>
          </div>
        </>
      )}
    </div>
  );
}